module.exports = __webpack_public_path__ + "0b6b920879306a303995e4bd3f1f9cf6.svg";